import { supabase } from '../lib/supabase'
import { validarLinkHotmart } from './link'

// perfis NAO entra na sincronizacao do aparelho: le e grava direto no
// Supabase. Sem internet, salvar devolve 'sem_internet' -- nunca um "Salvo"
// que nao chegou.
// Safari/iPhone diz "Load failed" em vez de "Failed to fetch" quando falta rede.
export function ehErroDeRede(mensagem: string): boolean {
  return /fetch|network|load failed/i.test(mensagem)
}

export async function lerLinkIndicacao(userId: string): Promise<string | null> {
  const { data, error } = await supabase.from('perfis').select('link_indicacao').eq('user_id', userId).maybeSingle()
  if (error) throw error
  return (data?.link_indicacao as string | null | undefined) ?? null
}

export async function salvarLinkIndicacao(
  userId: string, texto: string,
): Promise<'ok' | 'invalido' | 'sem_internet' | 'erro'> {
  const v = validarLinkHotmart(texto)
  if (!v.ok) return 'invalido'
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return 'sem_internet'
  const { data, error } = await supabase
    .from('perfis').update({ link_indicacao: v.link }).eq('user_id', userId).select('user_id')
  if (error) return ehErroDeRede(error.message) ? 'sem_internet' : 'erro'
  // RLS que recusa um update devolve 0 linhas, sem erro: tratar como erro.
  return data && data.length === 1 ? 'ok' : 'erro'
}
